<template>
    <div>
        <v-container class="mt-0">
            <v-row justify="center" align="center" align-content="center" no-gutters class="mt-12">
                <v-col class="pa-3 ma-3" offset-md="2" md="7">
                    <v-card>
                        <v-card-title><h1 class="title text-uppercase">Nous aider</h1>
                        </v-card-title>
                        <v-card-text><p>Vous avez envie de vous investir à nos côtés, de devenir bénévole et participer
                            à la bonne tenue de l’événement ? Nous avons aussi besoin de bras… N’hésitez pas à prendre
                            contact avec l’équipe organisatrice.</p>

                        </v-card-text>
                        <v-card-actions>
                            <contact-us color="orange"></contact-us>
                            <v-btn @click="$router.push({name:'subscribe'})" text color="orange">S'inscrire</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" offset-md="0" md="3" align-self="center">
                    <v-img
                            alt="Ludi Health"
                            class="shrink"
                            contain
                            src="@/assets/logo_banner.png"
                            transition="scale-transition"
                            max-width="438px"
                    />
                </v-col>
            </v-row>
            <v-row justify="center" align="center" align-content="center" no-gutters class="mt-12">
                <v-col align-self="center" class="ma-auto" style="max-width: 600px">
                    <v-card class="ma-auto">
                        <v-card-title><h2 class="title text-uppercase">Retour en image sur la première édition</h2>
                        </v-card-title>
                        <v-row justify="center" align="center" align-content="center" no-gutters class="mt-12">
                            <iframe width="100%" height="350"
                                    style="max-width: 560px"
                                    class="mb-2"
                                    src="https://www.youtube.com/embed/rvkqXMUmH5o?si=dhF-CVvomuUDYFK3"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-img src="../../public/img/health.webp" gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
               height="calc( 35vh - 48px )" class="white--text mt-10 mb-10" width="100%">
            <v-row
                    class="fill-height ma-0 text-center"
                    :class="$vuetify.breakpoint.smAndUp?'display-3':'display-1'"
                    align="center"
                    justify="center"
            >
                Les profils
            </v-row>
        </v-img>
        <v-container>
            <v-row justify="center" align="center" align-content="center" no-gutters>
                <v-col cols="12" md="3" offset-md="1" align-self="center">
                    <v-img src="@/assets/mecenat.png" max-width="450px" class="ma-auto"></v-img>
                </v-col>
                <v-col class="pa-3 ma-3" cols="12" md="6" offset-md="2">
                    <v-card>
                        <v-card-title>
                            <h2>
                                <v-icon>mdi-home-roof</v-icon>
                                Mécénat
                            </h2>
                        </v-card-title>
                        <v-card-text>
                            <p>Vous voulez soutenir l’événement, en devenir partenaire ou sponsor ? Vous serez bien sûr
                                accueillis avec grand plaisir. Les organisateurs vous proposent en retour une belle
                                visibilité tant sur le site que sur les documents de communication de Ludi’Health.</p>
                        </v-card-text>
                        <v-card-actions>
                            <contact-us color="orange" texte="Devenir mécène"></contact-us>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="0" md="2" order="3"></v-col>
            </v-row>
            <v-img src="../../public/img/health.webp"
                   gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
                   class="white--text mt-10 mb-10 " height="2em">
                <v-row align="center" justify="center" class="text-center">
                </v-row>
            </v-img>
            <v-row justify="center" align="center" align-content="center" no-gutters>
                <v-col cols="12" md="3" offset-md="1" align-self="center">
                    <v-img src="@/assets/coaching.jpg" max-width="450px" class="ma-auto"></v-img>
                </v-col>
                <v-col class="pa-3 ma-3" cols="12" md="6" offset-md="2">
                    <v-card>
                        <v-card-title>
                            <h2>
                                <v-icon>mdi-teach</v-icon>
                                Coaching
                            </h2>
                        </v-card-title>
                        <v-card-text>
                            <p>Aller le plus loin possible en de 48 heures, cela nécessite de s’appuyer sur des
                                compétences éprouvées. Nous cherchons les meilleurs talents en game-design,
                                level-design, mais aussi en programmation, graphisme, story-telling,... Votre aide sera
                                évidemment précieuse.</p>
                        </v-card-text>
                        <v-card-actions>
                            <contact-us color="orange" texte="Devenir coach"></contact-us>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="0" md="2" order="3"></v-col>
            </v-row>
            <v-img src="../../public/img/health.webp"
                   gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
                   class="white--text mt-10 mb-10 " height="2em">
                <v-row align="center" justify="center" class="text-center">
                </v-row>
            </v-img>
            <v-row justify="center" align="center" align-content="center" no-gutters>
                <v-col cols="12" md="3" offset-md="1" align-self="center">
                    <v-img src="@/assets/volunteers.png" max-width="450px" class="ma-auto"></v-img>
                </v-col>
                <v-col class="pa-3 ma-3" cols="12" md="6" offset-md="2">
                    <v-card>
                        <v-card-title>
                            <h2>
                                <v-icon>mdi-playlist-check</v-icon>
                                Participer
                            </h2>
                        </v-card-title>
                        <v-card-text>
                            <p>En cours de rédaction</p>
                            <profiles></profiles>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="$router.push({name:'subscribe'})" text color="orange">S'inscrire</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="0" md="2" order="3"></v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import ContactUs from "../components/ContactUs";
    import Profiles from "../components/Profiles";

    export default {
        name: "Help",
        components: {Profiles, ContactUs}
    }
</script>

<style scoped>

</style>